<template>
  <div class="Section">

    <app-background :backgroundImg="'./static/images/' + sharedContent.backgroundImgBlur"/>
    <app-audio :src="'./static/audio/' + galleryContent.sections[sectionIndex].audio"></app-audio>

    <!-- <div id="home" class="container Section-map" @wheel="debouncedScroll($event)"> -->
    <div id="home" class="container Section-map">

      <div class="row">
        <div class="col mt-3">
          <div 
            class="ButtonIcon ButtonIcon--small ButtonIcon--light mx-auto"
            title="Return to Wolves 101">
            <router-link to="/wolves-101">
              <icon name="home" scale=".85"></icon>
            </router-link>
          </div>
        </div>
      </div>

      <!-- section blurb -->
      <div class="row">
        <div class="col-md-10 col-xl-8 mx-auto mt-3">
          <div class="Blurb" :class="{ 'is-blurred': menuIsOpen }">
            <h2 class="Blurb-title text-center">
              {{ galleryContent.sections[sectionIndex].name || '' }}
            </h2>
            <p>
              {{ galleryContent.sections[sectionIndex].description || '' }}
            </p>
          </div>
        </div>
      </div>

      <!-- preview images -->
      <div class="row Section-map-preview">
      <!-- <div class="row"> -->
        <div class="col Section-map-wrapper">
          <div 
            class="Section-map-img"
            v-for="(subsection, i) in galleryContent.sections[sectionIndex].subsections" 
            :key="i"
            :class="[ 'Section-map-img--' + i, { 'is-blurred': menuIsOpen } ]">
            <img
              @click="jumpToId(subsection.id)"
              :src="'./static/images/gallery/' + galleryContent.sections[sectionIndex].directory + '/' + subsection.previewImage"
              :alt="subsection.name"
              :title="subsection.name">
          </div>
        </div>
      </div>

      <!-- table of contents -->
      <div class="row Contents Contents--centered">

      <transition name="fade">
        <div class="col-md-5 mx-auto Contents-container" v-if="menuIsOpen">
          <ol class="Contents-menu" v-on-clickaway="closeMenu">
            <li 
              class="Contents-menu-item"
              v-for="(subsection, i) in galleryContent.sections[sectionIndex].subsections" 
              :key="i"
              @click="jumpToId(subsection.id)">
              {{ subsection.name }}
            </li>
          </ol>
        </div>
      </transition>

      <div class="col-12 mx-auto">
        <button class="Button Button--dark mx-auto" @click="menuIsOpen = !menuIsOpen">
          {{ (menuIsOpen) ? 'Hide Contents' : 'Show Contents' }}
        </button>
      </div>
    </div>

    </div>

    <!-- subsection slides -->
    <app-gallery-slide 
      v-for="(subsection, i) in galleryContent.sections[sectionIndex].subsections"
      :key="subsection + i"
      :sectionIndex="sectionIndex"
      :slideIndex="i"
    />
  </div>
</template>

<script>
import appAudio from './../partials/audio'
import appBackground from './../partials/background'
import appGallerySlide from './../gallery/gallery-slide'
import { mixin as clickaway } from 'vue-clickaway'
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/home'
import jump from 'jump.js'

const _ = require('lodash')

export default {
  name: 'gallerySection',

  components: {
    appAudio,
    appBackground,
    appGallerySlide,
    Icon
  },

  data () {
    return {
      menuIsOpen: false,
      isAnimating: true,
      waypoint: null
    }
  },

  props: {
    sectionIndex: Number
  },

  computed: {
    galleryContent () {
      return this.$store.getters.galleryContent
    },

    sharedContent () {
      return this.$store.getters.sharedContent
    }
  },

  mixins: [ clickaway ],

  beforeCreate () {
    this.$store.dispatch('getLocalData', 'gallery')
  },

  created () {
    window.onbeforeunload = () => window.scrollTo(0, 0)
  },

  mounted () {
    /* eslint-disable */
    // require('waypoints/lib/noframework.waypoints')
    // setTimeout(() => {
    //   const vm = this;
    //   const slides = document.getElementsByClassName('Slide')
    //   console.log(slides)
    //   Array.prototype.forEach.call(slides, function (el, i) {
    //     vm.waypoint = new Waypoint({
    //       element: el,
    //       handler: function (direction) {
    //         if (direction === 'down') {
    //           const nextSection = slides[i + 1].id
    //           jump('#' + nextSection, {
    //             offset: 0
    //           })
    //         }
    //       },
    //       offset: function () {
    //         // following returns 'bottom-in-view' + 10px
    //         return (this.context.innerHeight() - this.adapter.outerHeight()) - 10
    //       },
    //       // offset: 'bottom-in-view',
    //       continuous: false
    //     })
    //   })
    // }, 1000)
    if (this.$route.query.id) {
      setTimeout(() => {
        jump(`#${this.$route.query.id}`)
      }, 1000)
    }
  },

  beforeDestroy () {
    // Waypoint.destroyAll()
  },

  methods: {
    closeMenu () {
      this.menuIsOpen = false
    },

    debouncedScroll: _.throttle(function (e) {
      // NOTE: mousewheel delta for IE
      const delta = (e.wheelDelta * -1) || e.deltaY
      const nextSection = this.galleryContent.sections[this.sectionIndex].subsections[0].id
      if (delta > 0) {
        jump('#' + nextSection, {
          offset: -78
        })
      }
    }, 1000, {
      leading: true,
      trailing: false
    }),

    jumpToId (selector) {
      // this.waypoint.group.waypoints.forEach(point => point.disable())
      const id = '#' + selector
      jump(id, {
        offset: -78
        // callback: () => this.waypoint.group.waypoints.forEach(point => point.enable())
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import './../../assets/_variables.scss';
@import './../../assets/_toc.scss';

@mixin Section-map-img($id, $posX, $posY, $width) {
  animation: $id 2s ease forwards;
  transform: translate($posX, $posY);
  width: $width;
}

.Section-map {
  min-height: calc(100vh - 80px);
  position: relative;
  @media screen and (min-width: $grid-xl) and (min-height: 900px) {
    max-height: calc(100vh - 80px);
  }
}

.Section-map-img {
  box-shadow: 0 0 15px 5px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  display: inline-block;
  max-width: 350px;
  transition: $transitionHover;
  @media screen and (max-width: $grid-xl), screen and (max-height: 800px) {
    margin: .75em 0;
    overflow: hidden;
    max-width: 30%;
    max-height: min-content;
    transform: translate(0) !important;
    width: auto !important;
  }
}

.Section-map-img--0 {
  @include Section-map-img(animateTopLeft, -2vw, 4vh, auto);
  @media screen and (min-height: 1024px) {
    transform: translate(-2vw, 3vh);
  }
  @media screen and (min-width: $grid-lg) {
    width: 225px;
  }
  @media screen and (min-width: $grid-xl) and (min-height: 1024px) {
    // transform: translate(-2vw, 3vh);
    width: auto;
  }
}

.Section-map-img--1 {
  @include Section-map-img(animateLeft, -1vw, 1vh, auto);
  @media screen and (min-height: 1024px) {
    transform: translate(-1vw, 1vh);
  }
  @media screen and (min-width: $grid-lg) {
    width: 225px;
  }
  @media screen and (min-width: $grid-xl) and (min-height: 1024px) {
    width: auto;
  }
}

.Section-map-img--2 {
  @include Section-map-img(animateTopRight, 0, 2.5vh, auto);
  @media screen and (min-height: 1024px) {
    transform: translate(0, 3.5vh);
  }
  @media screen and (min-width: $grid-lg) {
    width: 225px;
  }
  @media screen and (min-width: $grid-xl) and (min-height: 1024px) {
    width: auto;
  }
}

.Section-map-img--3 {
  @include Section-map-img(animateRight, 1.5vw, .5vh, auto);
  @media screen and (min-height: 1024px) {
    transform: translate(-4.5vw, 7.5vh);
  }
  @media screen and (min-width: $grid-lg) {
    width: 225px;
  }
  @media screen and (min-width: $grid-xl) and (min-height: 1024px) {
    width: auto;
  }
}

.Section-map-img--4 {
  @include Section-map-img(animateBottomRight, 2vw, 2vh, auto);
  @media screen and (min-height: 1024px) {
    transform: translate(-5vw, 10vh);
  }
  @media screen and (min-width: $grid-lg) {
    width: 225px;
  }
  @media screen and (min-width: $grid-xl) and (min-height: 1024px) {
    width: auto;
  }
}

.Section-map-img--5 {
  @include Section-map-img(animateBottom, 4vw, 11vh, auto);
  @media screen and (min-height: 1024px) {
    transform: translate(16vw, -14vh);
  }
  @media screen and (min-width: $grid-lg) {
    width: 225px;
  }
  @media screen and (min-width: $grid-xl) and (min-height: 1024px) {
    width: auto;
  }
}

.Section-map-img--6 {
  @include Section-map-img(animateBottomLeft, 14vw, 3vh, auto);
  @media screen and (min-height: 1024px) {
    transform: translate(24vw, 5vh);
  }
  @media screen and (min-width: $grid-lg) {
    width: 225px;
  }
  @media screen and (min-width: $grid-xl) and (min-height: 1024px) {
    width: auto;
  }
}

.Section-map-img--7 {
  @include Section-map-img(animateTopLeft, 15vw, 8vh, auto);
  @media screen and (min-height: 1024px) {
    transform: translate(22vw, -6vh);
  }
  @media screen and (min-width: $grid-lg) {
    width: 225px;
  }
  @media screen and (min-width: $grid-xl) and (min-height: 1024px) {
    width: auto;
  }
}

.Section-map-img--8 {
  @include Section-map-img(animateLeft, 30vw, 1vh, auto);
  @media screen and (min-height: 1024px) {
    transform: translate(22vw, -14vh);
  }
  @media screen and (min-width: $grid-lg) {
    width: 225px;
  }
  @media screen and (min-width: $grid-xl) and (min-height: 1024px) {
    width: auto;
  }
}

.Section-map-preview {
  height: auto;
  @media screen and (min-width: $grid-md) {
    height: 100%;
  }
}

.Section-map-wrapper {
  @media screen and (max-width: $grid-xl), screen and (max-height: 800px) {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
}

@keyframes animateTopLeft {
  from {
    opacity: 0;
    transform: translate(-100vw, -100vh);
  }
  to {
    opacity: 1;
  }
}

@keyframes animateLeft {
  from {
    opacity: 0;
    transform: translate(-100vw, -10vh);
  }
  to {
    opacity: 1;
  }
}

@keyframes animateTopRight {
  from {
    opacity: 0;
    transform: translate(200vw, -100vh);
  }
  to {
    opacity: 1;
  }
}

@keyframes animateRight {
  from {
    opacity: 0;
    transform: translate(200vw);
  }
  to {
    opacity: 1;
  }
}

@keyframes animateBottomRight {
  from {
    opacity: 0;
    transform: translate(-200vw);
  }
  to {
    opacity: 1;
  }
}

@keyframes animateBottom {
  from {
    opacity: 0;
    transform: translateY(200vh);
  }
  to {
    opacity: 1;
  }
}

@keyframes animateBottomLeft {
  from {
    opacity: 0;
    transform: translate(-100vw);
  }
  to {
    opacity: 1;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/gallery/gallery-section.vue